<template>
    <div class="sticky-table" style="width: 1300px;">
        <tr height="20" style='height:30.00pt;'>
        </tr>
        <tr height="26.67" style='height:20.00pt;mso-height-source:userset;mso-height-alt:400;'>
            <td class="qxzr65" height="53.33" rowspan="2"
                style='height:40.00pt;border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;min-width: 46px;' x:str>序号
            </td>
            <td class="qxzr66" rowspan="2"
                style='border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;min-width: 126px;' x:str>评价项目</td>
            <td class="qxzr661" rowspan="2"
                style='border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;min-width: 341px;' x:str>评价指标</td>
            <td class="qxzr67" colspan="4"
                style='border-right:.5pt solid windowtext;border-bottom:.5pt solid windowtext;' x:str>评分标准</td>
            <td class="qxzr68" :colspan="tableData.length" x:str>教师姓名(课程)</td>
            <td class="qxzr77"></td>
        </tr>

        <tr height="26.67" style='height:20.00pt;mso-height-source:userset;mso-height-alt:400;'>
            <td class="qxzr711" style="min-width: 57px;" x:str>优</td>
            <td class="qxzr712" style="min-width: 57px;" x:str>良</td>
            <td class="qxzr713" style="min-width: 57px;" x:str>中</td>
            <td class="qxzr714" style="min-width: 57px;" x:str>差</td>
            <template v-for="(item,index) in tableData">
                <td class="qxzr72" x:str>{{item[0].teaName}}<br />({{parseCourseName(item[0].courseName)}})</td>
            </template>
            <td class="qxzr77"></td>
        </tr>

        <template v-for="(item,row) in tableData[0]">
            <tr height="53.33" style='height:40.00pt;mso-height-source:userset;mso-height-alt:800;'>
                <td class="qxzr73" height="53.33" style='height:40.00pt;' x:num>{{item.xh}}</td>
                <td class="qxzr74" x:str>{{item.pjxmc}}</td>
                <td class="qxzr75" x:str>{{item.pjxnr}}</td>

                <td class="qxzr911" x:str>
                    <div v-html="item.y" />
                </td>
                <td class="qxzr912" x:str>
                    <div v-html="item.l" />
                </td>
                <td class="qxzr913" x:str>
                    <div v-html="item.z" />
                </td>
                <td class="qxzr914" x:str>
                    <div v-html="item.c" />
                </td>

                <template v-for="(itemB,column) in tableData">
                    <td class="qxzr76" x:num>
                        {{tableData[column][row].df}}
                    </td>
                </template>
                <td class="qxzr77"></td>
            </tr>
        </template>

        <tr height="20" style='height:30.00pt;'>
        </tr>

    </div>
</template>

<script>
    import {
        confirmMsg,
        showNotify
    } from "utils/message";

    export default {
        props: ['tableData'],
        data() {
            return {

            };
        },
        mounted() {},
        methods: {
            parseCourseName(str){
                let split = str.split("、");
                let set = new Set();
                split.forEach(item=>{
                    set.add(item)
                })
                str = "";
                set.forEach(item=>{
                    str += item + "、"
                })
                return str.substring(0, str.length - 1);
            },
        },
    };
</script>

<style scoped>
    .styleQxzr {
        mso-number-format: "General";
        text-align: general;
        vertical-align: middle;
        white-space: nowrap;
        mso-rotate: 0;
        color: windowtext;
        font-size: 12.0pt;
        font-weight: 400;
        font-style: normal;
        text-decoration: none;
        font-family: 宋体;
        mso-font-charset: 134;
        border: none;
        mso-protection: locked visible;
        mso-style-name: "常规";
        mso-style-id: 0;
    }

    td {
        mso-style-parent: styleQxzr;
        padding-top: 1px;
        padding-right: 1px;
        padding-left: 1px;
        mso-ignore: padding;
        mso-number-format: "General";
        text-align: general;
        vertical-align: middle;
        white-space: nowrap;
        mso-rotate: 0;
        color: windowtext;
        font-size: 12.0pt;
        font-weight: 400;
        font-style: normal;
        text-decoration: none;
        font-family: 宋体;
        mso-font-charset: 134;
        border: none;
        mso-protection: locked visible;
    }

    .qxzr65 {
        mso-style-parent: styleQxzr;
        text-align: center;
        font-weight: 700;
        mso-generic-font-family: auto;
        mso-font-charset: 134;
        border-left: 1.0pt solid windowtext;
        border-top: 1.0pt solid windowtext;
        border-right: .5pt solid windowtext;
        border-bottom: .5pt solid windowtext;

        position: sticky;
        left: 0;
        background-color: #ffffff;
    }

    .qxzr66 {
        mso-style-parent: styleQxzr;
        text-align: center;
        font-weight: 700;
        mso-generic-font-family: auto;
        mso-font-charset: 134;
        border-left: .5pt solid windowtext;
        border-top: 1.0pt solid windowtext;
        border-right: .5pt solid windowtext;
        border-bottom: .5pt solid windowtext;

        position: sticky;
        left: 46px;
        background-color: #ffffff;
    }

    .qxzr661 {
        mso-style-parent: styleQxzr;
        text-align: center;
        font-weight: 700;
        mso-generic-font-family: auto;
        mso-font-charset: 134;
        border-left: .5pt solid windowtext;
        border-top: 1.0pt solid windowtext;
        border-right: .5pt solid windowtext;
        border-bottom: .5pt solid windowtext;

        position: sticky;
        left: 172px;
        background-color: #ffffff;
    }

    .qxzr67 {
        mso-style-parent: styleQxzr;
        text-align: center;
        font-weight: 700;
        mso-font-charset: 134;
        border-left: .5pt solid windowtext;
        border-top: 1.0pt solid windowtext;
        border-right: .5pt solid windowtext;
        border-bottom: .5pt solid windowtext;

        position: sticky;
        left: 513px;
        background-color: #ffffff;
    }

    .qxzr68 {
        mso-style-parent: styleQxzr;
        text-align: center;
        font-weight: 700;
        mso-generic-font-family: auto;
        mso-font-charset: 134;
        border-left: .5pt solid windowtext;
        border-top: 1.0pt solid windowtext;
        border-right: 1.0pt solid windowtext;
        border-bottom: .5pt solid windowtext;
    }

    .qxzr69 {
        mso-style-parent: styleQxzr;
        text-align: center;
        font-weight: 700;
        mso-font-charset: 134;
        border-left: 1.0pt solid windowtext;
        border-top: .5pt solid windowtext;
        border-right: .5pt solid windowtext;
        border-bottom: .5pt solid windowtext;
    }

    .qxzr70 {
        mso-style-parent: styleQxzr;
        text-align: center;
        font-weight: 700;
        mso-font-charset: 134;
        border: .5pt solid windowtext;
    }

    .qxzr711 {
        mso-style-parent: styleQxzr;
        text-align: center;
        mso-font-charset: 134;
        border: .5pt solid windowtext;

        position: sticky;
        left: 513px;
        background-color: #ffffff;
    }

    .qxzr712 {
        mso-style-parent: styleQxzr;
        text-align: center;
        mso-font-charset: 134;
        border: .5pt solid windowtext;

        position: sticky;
        left: 570px;
        background-color: #ffffff;
    }

    .qxzr713 {
        mso-style-parent: styleQxzr;
        text-align: center;
        mso-font-charset: 134;
        border: .5pt solid windowtext;

        position: sticky;
        left: 627px;
        background-color: #ffffff;
    }

    .qxzr714 {
        mso-style-parent: styleQxzr;
        text-align: center;
        mso-font-charset: 134;
        border: .5pt solid windowtext;

        position: sticky;
        left: 684px;
        background-color: #ffffff;
    }

    .qxzr72 {
        mso-style-parent: styleQxzr;
        text-align: center;
        white-space: normal;
        mso-font-charset: 134;
        border-left: .5pt solid windowtext;
        border-top: .5pt solid windowtext;
        border-right: 1.0pt solid windowtext;
        border-bottom: .5pt solid windowtext;
        white-space: normal;
        width: 10%;

/*        position: sticky;
        left: 741px;
        background-color: #ffffff; */
    }

    .qxzr73 {
        mso-style-parent: styleQxzr;
        text-align: center;
        mso-font-charset: 134;
        border-left: 1.0pt solid windowtext;
        border-top: .5pt solid windowtext;
        border-right: .5pt solid windowtext;
        border-bottom: 1.0pt solid windowtext;

        position: sticky;
        left: 0;
        background-color: #ffffff;
    }

    .qxzr74 {
        mso-style-parent: styleQxzr;
        text-align: center;
        white-space: normal;
        mso-font-charset: 134;
        border-left: .5pt solid windowtext;
        border-top: .5pt solid windowtext;
        border-right: .5pt solid windowtext;
        border-bottom: 1.0pt solid windowtext;

        position: sticky;
        left: 46px;
        background-color: #ffffff;
    }

    .qxzr911 {
        mso-style-parent: styleQxzr;
        text-align: center;
        white-space: normal;
        mso-font-charset: 134;
        border-left: .5pt solid windowtext;
        border-top: .5pt solid windowtext;
        border-right: .5pt solid windowtext;
        border-bottom: 1.0pt solid windowtext;
        font-size: 8px;

        position: sticky;
        left: 513px;
        background-color: #ffffff;
    }

    .qxzr912 {
        mso-style-parent: styleQxzr;
        text-align: center;
        white-space: normal;
        mso-font-charset: 134;
        border-left: .5pt solid windowtext;
        border-top: .5pt solid windowtext;
        border-right: .5pt solid windowtext;
        border-bottom: 1.0pt solid windowtext;
        font-size: 8px;

        position: sticky;
        left: 570px;
        background-color: #ffffff;
    }

    .qxzr913 {
        mso-style-parent: styleQxzr;
        text-align: center;
        white-space: normal;
        mso-font-charset: 134;
        border-left: .5pt solid windowtext;
        border-top: .5pt solid windowtext;
        border-right: .5pt solid windowtext;
        border-bottom: 1.0pt solid windowtext;
        font-size: 8px;

        position: sticky;
        left: 627px;
        background-color: #ffffff;
    }

    .qxzr914 {
        mso-style-parent: styleQxzr;
        text-align: center;
        white-space: normal;
        mso-font-charset: 134;
        border-left: .5pt solid windowtext;
        border-top: .5pt solid windowtext;
        border-right: .5pt solid windowtext;
        border-bottom: 1.0pt solid windowtext;
        font-size: 8px;

        position: sticky;
        left: 684px;
        background-color: #ffffff;
    }

    .qxzr75 {
        mso-style-parent: styleQxzr;
        text-align: left;
        mso-font-charset: 134;
        border-left: .5pt solid windowtext;
        border-top: .5pt solid windowtext;
        border-right: .5pt solid windowtext;
        border-bottom: 1.0pt solid windowtext;
        white-space: normal;

        position: sticky;
        left: 172px;
        background-color: #ffffff;
    }

    .qxzr76 {
        mso-style-parent: styleQxzr;
        text-align: center;
        mso-font-charset: 134;
        border-left: .5pt solid windowtext;
        border-top: .5pt solid windowtext;
        border-right: 1.0pt solid windowtext;
        border-bottom: 1.0pt solid windowtext;

        min-width: 160px;

 /*       position: sticky;
        left: 741px;
        background-color: #ffffff; */
    }

    .qxzr77 {
        border-left: .5pt solid windowtext;

        position: sticky;
        right: -1px;
        background-color: #ffffff;
    }

    .sticky-table {
        overflow: auto;
        width: 100%;
        /* position: absolute */
    }
</style>



// WEBPACK FOOTER //
// queryXzrEvaluate.vue?529b4a9b